import { createAction } from 'redux-actions';
import types from './types';

export const getUserLocations = createAction(types.SAVE_USER_LOCATIONS);
export const removeUserLocation = createAction(types.REMOVE_USER_LOCATION);
export const activateUserLocation = createAction(types.ACTIVATE_USER_LOCATION);
export const setNewPrimaryLocation = createAction(types.SET_PRIMARY_LOCATION);
export const addLocation = createAction(types.ADD_LOCATION);
export const updateLocation = createAction(types.UPDATE_LOCATION);
